function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.37,311.22l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.06h-.44v-.45L665.39,300v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V300c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55.05L679,311Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.6,325.33l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.06h-.44v-.45l0-11.19v-.5h.5l13.24.07c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.83.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55.05l6.57.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.14,325.33l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.07c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.14-5.65c0-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.19,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.79,178.07l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7,0h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,192.18l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.05h-.44v-.45L273,181v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28V181c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5L274,192.18l-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.56,192.18l-13.12.28-6.66.11c-2.23,0-4.46,0-6.7.05h-.44v-.45L302.58,181v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V181c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.19,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.88,252.11l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.05H72v-.45l0-11.19v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.86,178.06l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.82.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.84,69.38l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.06h-.44v-.45l0-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41,0-8.83.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.61,83.49l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.09,3.79-.14,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.34,69.39l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06h-.45v-.45l0-11.19v-.5h.51l13.24.07c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.15-5.65c0-1.86-.11-3.71-.13-5.54l.28.27c-4.42.06-8.83.16-13.24.17l-13.24.06.5-.5L43.3,69.39,42.86,69c2.18,0,4.35,0,6.54,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.77,
    y: 60.22,
    width: 118.54,
    height: 79.88,
    style: {
      fill: "#fff",
      stroke: "#ebebeb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.23,66.26a2.73,2.73,0,1,1-2.73-2.73A2.73,2.73,0,0,1,111.23,66.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.37,66.26a2.73,2.73,0,1,1-2.72-2.73A2.72,2.72,0,0,1,122.37,66.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.52,66.26a2.73,2.73,0,1,1-2.73-2.73A2.73,2.73,0,0,1,133.52,66.26Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.77,
    y1: 72.25,
    x2: 218.31,
    y2: 72.25,
    style: {
      fill: "none",
      stroke: "#ebebeb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,165.58c0-1.25.17-4.58.17-6,0-6.08-2.17-8.83-7.83-9-2.66-.16-4.24-1.74-4.24-4s1.58-3.83,4.24-4c5.66-.25,7.83-2.91,7.83-9.08,0-1.41-.17-4.74-.17-6,0-8.08,3.42-13.24,16.32-16.07,2.59-.59,4.58,1,4.58,3.41a3.49,3.49,0,0,1-2.33,3.41c-8.07,2.5-9.24,5.08-9.24,10.75,0,1.66.17,4.41.17,6.16,0,6.49-3.17,9.66-8.66,11.41,5.58,1.83,8.66,4.91,8.66,11.41,0,1.74-.17,4.49-.17,6.16,0,5.66,1.17,8.24,9.24,10.74a3.49,3.49,0,0,1,2.33,3.41c0,2.42-2,4-4.58,3.42C203.42,178.91,200,173.74,200,165.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.8,127.53c0,1.25-.17,4.58-.17,6,0,6.17,2.25,8.83,7.92,9.08,2.58.17,4.16,1.75,4.16,4s-1.58,3.83-4.16,4c-5.67.17-7.92,2.92-7.92,9,0,1.41.17,4.74.17,6,0,8.16-3.41,13.33-16.32,16.16-2.58.58-4.58-1-4.58-3.42a3.45,3.45,0,0,1,2.41-3.41c8-2.5,9.16-5.08,9.16-10.74,0-1.67-.16-4.42-.16-6.16,0-6.5,3.16-9.66,8.66-11.41-5.58-1.83-8.66-4.92-8.66-11.41,0-1.75.16-4.5.16-6.16,0-5.67-1.16-8.25-9.16-10.75a3.45,3.45,0,0,1-2.41-3.41c0-2.41,2-4,4.58-3.41C245.39,114.29,248.8,119.45,248.8,127.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.2,318.6a3.39,3.39,0,0,1-2.37,5.81,3.55,3.55,0,0,1-2.47-1L292.23,308.1c-.16-.05-.21-.16-.27-.32a.91.91,0,0,0-.16-.11,1.26,1.26,0,0,1-.16-.43.27.27,0,0,1-.16-.21c-.06-.11-.06-.27-.11-.33s-.11-.21-.11-.27v-.37c0-.11-.05-.16-.05-.33s.05-.21.05-.26v-.38c0-.11.11-.16.11-.22s.05-.27.11-.43,0-.05,0-.1a3.59,3.59,0,0,1,.27-.49.11.11,0,0,1,.11-.11,1,1,0,0,1,.32-.37L307.36,288a3.51,3.51,0,0,1,4.84,0,3.42,3.42,0,0,1,0,4.84l-12.76,12.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.92,320.32l13.19-31.38a3,3,0,0,1,3.93-1.56,2.91,2.91,0,0,1,1.51,3.82l-13.19,31.44a3,3,0,0,1-2.75,1.77,2.55,2.55,0,0,1-1.07-.21A2.92,2.92,0,0,1,325.92,320.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.59,307.67s0,.06,0,.06a2.58,2.58,0,0,1-.37.37L355,323.44a3.5,3.5,0,0,1-4.84,0,3.4,3.4,0,0,1,0-4.84L363,305.73,350.2,292.87a3.4,3.4,0,0,1,0-4.84,3.51,3.51,0,0,1,4.84,0l15.13,15.34a2.58,2.58,0,0,1,.37.37s0,.11,0,.11a3.64,3.64,0,0,1,.27.49c0,.05.06.05.06.1a2.29,2.29,0,0,0,.16.49c0,.05.05.05.05.16v.38s.06.21.06.26-.06.22-.06.27v.43c0,.06-.05.06-.05.11a3.75,3.75,0,0,0-.16.49c0,.05-.06.05-.06.16S370.7,307.46,370.59,307.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.5,140.33a12.9,12.9,0,0,1-12,12.87v0H501.46A15.17,15.17,0,0,1,500,123a25.56,25.56,0,0,1,49.53-8A15.18,15.18,0,0,1,571.5,127.6a12,12,0,0,1,2.09-.17A12.91,12.91,0,0,1,586.5,140.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.58,235.48a3.72,3.72,0,0,1,3.92,0c.33.2.67.39,1,.57s.69.36,1,.53a3.74,3.74,0,0,1,2.19,3.24l.15,4.83,15.72-.49-.15-4.86a3.72,3.72,0,0,1,2-3.36,21.8,21.8,0,0,0,2-1.21,3.78,3.78,0,0,1,3.94-.27l4.24,2.28L132,222.9l-4.24-2.28a3.78,3.78,0,0,1-2-3.43,21.81,21.81,0,0,0-.07-2.29,3.73,3.73,0,0,1,1.7-3.52l4.13-2.56-8.29-13.37L119.16,198a3.66,3.66,0,0,1-3.85,0c-.34-.21-.7-.41-1.06-.61l-1.09-.55a3.69,3.69,0,0,1-2.14-3.22l-.14-4.84-15.73.49.16,4.82a3.68,3.68,0,0,1-1.91,3.35,23.52,23.52,0,0,0-2.13,1.32,3.64,3.64,0,0,1-3.84.21l-4.25-2.27-7.44,13.87L80,212.85a3.77,3.77,0,0,1,2,3.44,21.81,21.81,0,0,0,.07,2.29,3.73,3.73,0,0,1-1.71,3.52l-4.12,2.55L84.48,238Zm3.24-23.3a12.89,12.89,0,1,1,4.54,15A12.89,12.89,0,0,1,91.82,212.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.68,110.32a2.62,2.62,0,0,1,2.43-1.28l.81,0,.82,0a2.6,2.6,0,0,1,2.42,1.28l1.69,2.93,9.55-5.51-1.69-2.93a2.6,2.6,0,0,1,.1-2.75c.29-.46.57-.93.82-1.42A2.63,2.63,0,0,1,186,99.19h3.37v-11H186a2.63,2.63,0,0,1-2.33-1.45c-.25-.49-.53-1-.82-1.42a2.6,2.6,0,0,1-.1-2.75l1.69-2.93-9.55-5.51-1.7,3a2.61,2.61,0,0,1-2.42,1.27l-.81,0-.81,0a2.62,2.62,0,0,1-2.43-1.28L165,74.11l-9.55,5.51,1.69,2.92a2.62,2.62,0,0,1-.09,2.75,15.64,15.64,0,0,0-.83,1.43,2.63,2.63,0,0,1-2.33,1.45h-3.37v11h3.37a2.63,2.63,0,0,1,2.33,1.45,15.64,15.64,0,0,0,.83,1.43,2.62,2.62,0,0,1,.09,2.75l-1.69,2.92,9.55,5.51Zm-5.79-16.64a9,9,0,1,1,9,9A9,9,0,0,1,160.89,93.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.26,108.16l-5.51-9.55-2.92,1.69a2.62,2.62,0,0,1-2.75-.09,15.64,15.64,0,0,0-1.43-.83,2.63,2.63,0,0,1-1.45-2.33V93.68h-11v3.37a2.63,2.63,0,0,1-1.45,2.33,15.64,15.64,0,0,0-1.43.83,2.62,2.62,0,0,1-2.75.09l-2.92-1.69-5.51,9.55,2.94,1.69a2.62,2.62,0,0,1,1.28,2.43c0,.27,0,.54,0,.81s0,.54,0,.81a2.61,2.61,0,0,1-1.27,2.42l-3,1.7,5.51,9.55,2.93-1.69a2.62,2.62,0,0,1,2.75.1,15.38,15.38,0,0,0,1.42.82,2.63,2.63,0,0,1,1.45,2.33v3.37h11v-3.37a2.63,2.63,0,0,1,1.45-2.33,15.38,15.38,0,0,0,1.42-.82,2.62,2.62,0,0,1,2.75-.1l2.93,1.69,5.51-9.55-2.94-1.69a2.61,2.61,0,0,1-1.27-2.42c0-.27,0-.54,0-.82s0-.54,0-.81a2.62,2.62,0,0,1,1.28-2.43Zm-10.54,4.93a9,9,0,1,1-9-9A9,9,0,0,1,663.72,113.09Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-71"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.28,
    y: 70.08,
    width: 223.81,
    height: 141.2,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.28,
    y: 70.08,
    width: 223.81,
    height: 12.44,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,76.39a3.13,3.13,0,1,1-3.13-3.13A3.13,3.13,0,0,1,427,76.39Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.73,76.39a3.13,3.13,0,1,1-3.13-3.13A3.13,3.13,0,0,1,439.73,76.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.52,76.39a3.13,3.13,0,1,1-3.13-3.13A3.13,3.13,0,0,1,452.52,76.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.62,
    y: 107.26,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.12,
    y: 107.26,
    width: 107.4,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.6,
    y: 107.26,
    width: 12.63,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.81,
    y: 139.76,
    width: 12.63,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 566.97,
    y: 107.26,
    width: 42.58,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.27,
    y: 113.76,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 113.76,
    width: 50.06,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.88,
    y: 139.76,
    width: 18.93,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.12,
    y: 133.26,
    width: 47.81,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 120.26,
    width: 33.54,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.04,
    y: 126.76,
    width: 33.54,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.86,
    y: 120.26,
    width: 84.68,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.12,
    y: 139.76,
    width: 105.43,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.57,
    y: 113.76,
    width: 55.4,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.8,
    y: 113.76,
    width: 63.02,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.81,
    y: 120.26,
    width: 21.53,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.27,
    y: 120.26,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.62,
    y: 126.76,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.12,
    y: 126.76,
    width: 39.3,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 146.26,
    width: 39.3,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 152.76,
    width: 50.62,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.09,
    y: 146.26,
    width: 70.53,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482.14,
    y: 152.76,
    width: 65.43,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 152.76,
    width: 11.38,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.63,
    y: 133.26,
    width: 73.6,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 566.97,
    y: 133.26,
    width: 47.77,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.41,
    y: 126.76,
    width: 73.54,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.62,
    y: 133.26,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.62,
    y: 139.76,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.27,
    y: 146.26,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.27,
    y: 152.76,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.62,
    y: 158.21,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.12,
    y: 158.21,
    width: 77.97,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.27,
    y: 164.71,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 164.71,
    width: 50.06,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 171.21,
    width: 33.54,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.86,
    y: 171.21,
    width: 84.68,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.57,
    y: 164.71,
    width: 55.4,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.8,
    y: 164.71,
    width: 63.02,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.27,
    y: 171.21,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.73,100.86a.58.58,0,0,1-.82.83l-2.57-2.6s0,0,0-.06l0,0a.21.21,0,0,1,0-.07.05.05,0,0,1,0,0,.11.11,0,0,1,0-.05s0,0,0,0v-.06s0,0,0-.06,0,0,0,0v-.07l0,0a.22.22,0,0,1,0-.08h0a.73.73,0,0,1,0-.09s0,0,0,0a.15.15,0,0,1,0-.07l2.57-2.6a.59.59,0,0,1,.82,0,.57.57,0,0,1,0,.82l-2.16,2.18Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.05,101.16l2.24-5.32a.5.5,0,0,1,.66-.27.49.49,0,0,1,.26.65L436,101.55a.5.5,0,0,1-.46.3.37.37,0,0,1-.18,0A.49.49,0,0,1,435.05,101.16Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.63,99h0l-.07.07-2.56,2.6a.59.59,0,0,1-.41.16.57.57,0,0,1-.41-.16.59.59,0,0,1,0-.83l2.16-2.18-2.16-2.18a.57.57,0,0,1,0-.82.59.59,0,0,1,.82,0l2.56,2.6.07.07a0,0,0,0,1,0,0,.79.79,0,0,0,0,.09h0a.47.47,0,0,0,0,.09s0,0,0,0v.07s0,0,0,0,0,0,0,0v.07s0,0,0,0,0,.06,0,.08,0,0,0,0A.59.59,0,0,0,442.63,99Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.92,
    y: 97.3,
    width: 223.81,
    height: 141.2,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.92,
    y: 97.3,
    width: 223.81,
    height: 12.44,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.59,103.61a3.13,3.13,0,1,1-3.13-3.13A3.13,3.13,0,0,1,122.59,103.61Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.24,
    cy: 103.61,
    r: 3.13,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.16,103.61a3.14,3.14,0,1,1-3.14-3.13A3.14,3.14,0,0,1,148.16,103.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 134.48,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 134.48,
    width: 87.4,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.46,
    y: 134.48,
    width: 26.2,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.24,
    y: 134.48,
    width: 12.63,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.45,
    y: 166.98,
    width: 12.63,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.61,
    y: 134.48,
    width: 35.58,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 140.98,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.24,
    y: 140.98,
    width: 50.06,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.52,
    y: 166.98,
    width: 18.93,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 160.48,
    width: 47.81,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.24,
    y: 147.48,
    width: 33.54,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.68,
    y: 153.98,
    width: 33.54,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 147.48,
    width: 64.68,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 166.98,
    width: 85.43,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.2,
    y: 140.98,
    width: 48.4,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.44,
    y: 140.98,
    width: 43.02,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.6,
    y: 147.48,
    width: 14.53,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 147.48,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 153.98,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 153.98,
    width: 39.3,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.24,
    y: 173.48,
    width: 39.3,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.44,
    y: 179.98,
    width: 43.62,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.73,
    y: 173.48,
    width: 50.53,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.58,
    y: 179.98,
    width: 45.43,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.24,
    y: 179.98,
    width: 14.77,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.29,
    y: 179.98,
    width: 11.38,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.27,
    y: 160.48,
    width: 53.6,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.61,
    y: 160.48,
    width: 40.77,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.05,
    y: 153.98,
    width: 53.54,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 160.48,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 166.98,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 173.48,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.03,
    y: 173.48,
    width: 32.32,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.24,
    y: 185.37,
    width: 32.32,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 179.98,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 185.42,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 185.42,
    width: 77.97,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.97,
    y: 185.42,
    width: 25.16,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.88,
    y: 185.42,
    width: 21.98,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 191.92,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.24,
    y: 191.92,
    width: 50.06,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 211.43,
    width: 47.81,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.24,
    y: 198.42,
    width: 33.54,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 198.42,
    width: 64.68,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 217.93,
    width: 85.43,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.2,
    y: 191.92,
    width: 48.4,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.44,
    y: 191.92,
    width: 43.02,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.45,
    y: 198.42,
    width: 14.53,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 198.42,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 204.93,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.75,
    y: 204.93,
    width: 39.3,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.22,
    y: 204.93,
    width: 39.3,
    height: 2.43,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.27,
    y: 211.43,
    width: 73.6,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.05,
    y: 204.93,
    width: 53.54,
    height: 2.43,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 211.43,
    width: 6.65,
    height: 2.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.37,128.08a.57.57,0,0,1,0,.82.6.6,0,0,1-.4.17.59.59,0,0,1-.42-.17L125,126.3a.05.05,0,0,1,0,0l0,0a.26.26,0,0,1,0-.08,0,0,0,0,1,0,0s0-.05,0-.06,0,0,0,0V126a.2.2,0,0,1,0,0s0,0,0-.05v-.06s0,0,0,0a.64.64,0,0,0,0-.07s0,0,0,0a.56.56,0,0,1,0-.08,0,0,0,0,1,0,0,.13.13,0,0,1,0-.06l2.57-2.6a.59.59,0,0,1,.82,0,.57.57,0,0,1,0,.82l-2.17,2.18Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69,128.37l2.24-5.32a.5.5,0,0,1,.66-.26.49.49,0,0,1,.26.65l-2.24,5.33a.5.5,0,0,1-.46.3.43.43,0,0,1-.19,0A.5.5,0,0,1,130.69,128.37Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.26,126.23h0l-.07.06-2.56,2.6a.6.6,0,0,1-.41.17.57.57,0,0,1-.41-.17.57.57,0,0,1,0-.82L137,125.9l-2.16-2.18a.57.57,0,0,1,0-.82.59.59,0,0,1,.82,0l2.56,2.6.07.06v0s0,0,.05.08,0,0,0,0a.26.26,0,0,0,0,.08s0,0,0,0v.06s0,0,0,.05V126s0,0,0,0a.41.41,0,0,0,0,.08s0,0,0,0Z",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-71"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "55.82 425.76 135.62 425.51 215.41 425.43 375 425.26 534.59 425.42 614.38 425.51 694.18 425.76 614.38 426 534.59 426.09 375 426.25 215.41 426.09 135.62 426 55.82 425.76",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Devices--inject-71"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.73,
    y: 423.24,
    width: 111.19,
    height: 4.99,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.73,
    y: 423.24,
    width: 55.97,
    height: 4.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.4 428.23 345.77 428.23 361.08 354.63 252.71 354.63 237.4 428.23",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.84,393.07a6.38,6.38,0,0,0,6.46,7.22,8.22,8.22,0,0,0,8-7.22,6.38,6.38,0,0,0-6.47-7.22A8.21,8.21,0,0,0,290.84,393.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.38,
    y: 423.24,
    width: 111.19,
    height: 4.99,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.61,
    y: 423.24,
    width: 55.97,
    height: 4.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "510.9 428.23 402.54 428.23 387.23 354.63 495.59 354.63 510.9 428.23",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.46,393.07a6.38,6.38,0,0,1-6.46,7.22,8.21,8.21,0,0,1-8-7.22,6.38,6.38,0,0,1,6.46-7.22A8.21,8.21,0,0,1,457.46,393.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.81,336.52c-9.68,0-17.26-20.31-17.26-46.24S486.13,244,495.81,244s17.26,20.31,17.26,46.24S505.49,336.52,495.81,336.52Zm0-89.48c-6.89,0-14.26,17.38-14.26,43.24s7.37,43.24,14.26,43.24,14.26-17.37,14.26-43.24S502.7,247,495.81,247Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.86,318c-5.5,0-9.35-1.56-11.09-4.58-2.45-4.24-.34-10.61,5.93-17.93,5.94-6.93,15-14.08,25.48-20.13s21.21-10.32,30.18-12c9.48-1.77,16-.42,18.49,3.82s.34,10.61-5.93,17.93c-5.94,6.93-15,14.08-25.48,20.14s-21.21,10.31-30.18,12A40.39,40.39,0,0,1,466.86,318Zm58-52.41a38.49,38.49,0,0,0-6.94.72c-8.64,1.62-19,5.75-29.23,11.64s-19,12.82-24.7,19.49c-5.31,6.2-7.35,11.47-5.62,14.48s7.33,3.87,15.35,2.37c8.64-1.61,19-5.75,29.23-11.64s19-12.82,24.7-19.49c5.31-6.19,7.35-11.47,5.62-14.48C532.08,266.62,529.13,265.57,524.85,265.57Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.76,318a40.48,40.48,0,0,1-7.4-.76c-9-1.68-19.69-5.94-30.18-12S467.64,292,461.7,285.09c-6.27-7.32-8.38-13.69-5.93-17.93s9-5.59,18.49-3.82c9,1.68,19.69,5.94,30.18,12s19.54,13.2,25.48,20.13c6.27,7.32,8.38,13.69,5.93,17.93C534.11,316.42,530.26,318,524.76,318Zm-58-52.41c-4.28,0-7.23,1.05-8.41,3.09-1.73,3,.31,8.29,5.62,14.48,5.72,6.67,14.5,13.6,24.7,19.49s20.59,10,29.23,11.64c8,1.5,13.61.64,15.35-2.37s-.31-8.28-5.62-14.48c-5.72-6.67-14.49-13.59-24.7-19.49s-20.59-10-29.23-11.64A38.49,38.49,0,0,0,466.77,265.57Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.81,
    cy: 290.28,
    r: 6.79,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.67 256.81 249.24 333.71 202.8 256.81 237.35 256.81 249.24 279.14 261.12 256.81 295.67 256.81",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.86 256.81 249.24 305.59 220.61 256.81 237.35 256.81 249.24 279.14 261.12 256.81 277.86 256.81",
    style: {
      fill: "#000102",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.94 177.44 414.1 244.26 375 256.68 335.9 244.26 324.06 177.44 375 152.57 425.94 177.44",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375 251.36 375 157.89 420.68 180.19 410.07 240.12 375 251.36",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.52,177.86h9l20,52.53H389l-4.88-13.1H365.79L361,230.39H350.47Zm11.77,32.25L375,189.47l-7.55,20.64Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursor--inject-71"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "416.16 261.52 420.55 272.13 416.17 273.94 411.75 263.26 404.5 268.89 404.5 239.01 425.42 260.14 416.16 261.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.5,235.76a4,4,0,0,1-.26-1.5,4,4,0,0,1,.26-1.51,4,4,0,0,1,.27,1.51A4,4,0,0,1,404.5,235.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.92,236.83a4.39,4.39,0,0,1-2.13-2.12,3.74,3.74,0,0,1,1.25.87A4,4,0,0,1,401.92,236.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.84,239.42a4.46,4.46,0,0,1-3,0,4.3,4.3,0,0,1,3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.92,242a4.47,4.47,0,0,1-2.13,2.13,4.47,4.47,0,0,1,2.13-2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.16,239.42a4,4,0,0,1,1.5-.27,4,4,0,0,1,1.51.27,4,4,0,0,1-1.51.26A4,4,0,0,1,408.16,239.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.09,236.83a4.17,4.17,0,0,1,.87-1.25,3.84,3.84,0,0,1,1.25-.87,3.84,3.84,0,0,1-.87,1.25A4.17,4.17,0,0,1,407.09,236.83Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBg);
export default __webpack_public_path__ + "static/media/banner_bg.d18f49dbfacec3162da032a2cd6c6203.svg";
export { ForwardRef as ReactComponent };